import { useMemo } from "react";

import { noop } from "lodash";

import { CHART_NOTES_VISIT_TYPE } from "constants/chart-notes";
import { useGetChartNotesQuery } from "services/chart-notes";

export default function useMostRecentIcd10Codes(patientId: number | undefined) {
  const {
    data: latestCreatedNotes = [],
    isLoading,
    isUninitialized,
    refetch
  } = useGetChartNotesQuery(
    {
      search: "",
      patient: Number(patientId),
      ordering: "-display_moment",
      limit: 25,
      type: CHART_NOTES_VISIT_TYPE,
      query: "{icd10_codes,created_at}"
    },
    {
      skip: !patientId
    }
  );

  const mostRecentIcd10Codes = useMemo(() => {
    return (
      latestCreatedNotes
        .filter((chartNote) => (chartNote.icd10_codes ?? []).length > 0)
        .at(0)?.icd10_codes ?? []
    );
  }, [latestCreatedNotes]);

  return {
    mostRecentIcd10Codes,
    isLoading,
    isLatestCreatedNotesUninitialized: isUninitialized,
    refetchLatestCreatedNotes: patientId ? refetch : noop
  };
}
